<template>
  <v-main>
    <v-container class="page-fill-center page-fill-center--no-appbar" fluid>
      <v-row class="align-center justify-center">
        <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
          <v-icon :icon="mdiTools" size="64" color="primary" class="mb-4" />
          <h1 class="text-headline-small mb-2" data-testid="maintenance-title">Maintenance mode</h1>
          <p class="text-body-large text-medium-emphasis" data-testid="maintenance-message">
            We're briefly offline for scheduled maintenance. Back soon.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts" setup>
import { mdiTools } from "@mdi/js";
</script>
